
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[year]/[month]/[day]/[slug]",
      function () {
        return require("private-next-pages/news/[year]/[month]/[day]/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/[year]/[month]/[day]/[slug]"])
      });
    }
  